import { render, staticRenderFns } from "./TrackingInsightPopup.vue?vue&type=template&id=0c237a38&scoped=true"
import script from "./TrackingInsightPopup.vue?vue&type=script&lang=js"
export * from "./TrackingInsightPopup.vue?vue&type=script&lang=js"
import style0 from "./TrackingInsightPopup.vue?vue&type=style&index=0&id=0c237a38&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c237a38",
  null
  
)

export default component.exports